import { useRef } from "react";

/** 6-box OTP input — shared by registration and the owner-creates-operator flow. */
export default function OtpBoxes({ value, onChange, onComplete, autoFocus, error }) {
  const refs = useRef([]);
  const digits = Array.from({ length: 6 }, (_, i) => value[i] || "");

  const handleKey = (i, e) => {
    if (e.key === "Backspace") {
      if (!digits[i] && i > 0) refs.current[i - 1]?.focus();
      const next = digits.map((d, idx) => (idx === i ? "" : d)).join("");
      onChange(next);
    }
  };

  const handleChange = (i, e) => {
    const char = e.target.value.replace(/\D/g, "").slice(-1);
    const next = digits.map((d, idx) => (idx === i ? char : d)).join("");
    onChange(next);
    if (char && i < 5) refs.current[i + 1]?.focus();
    if (next.length === 6 && /^\d{6}$/.test(next)) onComplete?.(next);
  };

  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!pasted) return;
    e.preventDefault();
    onChange(pasted.padEnd(6, "").slice(0, 6));
    const focusIdx = Math.min(pasted.length, 5);
    refs.current[focusIdx]?.focus();
    if (pasted.length === 6) onComplete?.(pasted);
  };

  return (
    <div className="flex gap-2 justify-center" onPaste={handlePaste}>
      {digits.map((d, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={d}
          autoFocus={autoFocus && i === 0}
          onChange={(e) => handleChange(i, e)}
          onKeyDown={(e) => handleKey(i, e)}
          className={`w-10 h-12 sm:w-12 sm:h-14 text-center text-lg font-bold border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-400 bg-white dark:bg-zinc-800 dark:text-zinc-100 transition-colors ${
            error
              ? "border-red-500"
              : d
              ? "border-orange-400"
              : "border-zinc-300 dark:border-zinc-600"
          }`}
        />
      ))}
    </div>
  );
}
